/*@flow*/
import * as I from 'immutable';

// collPaths descends down a Map and gathers the path to the first
// non-Collection node in the map.
//
// Input: Map {a: {b: {c: {id: 'foo-1', type: 'foo'}, d: {id: 'foo-2', type: 'foo', list: ['foo']}}}}
// Output: List [['a', 'b', 'c', 'id'], ['a', 'b', 'c', 'type'], ['a', 'b', 'd', 'id'], ['a', 'b', 'd', 'type'], ['a', 'b', 'd', 'list', 0, 'foo']]
function collPaths(o: any) {
  let ret = I.List<I.List<string>>();
  const getPath = (v, path) => {
    if (I.Map.isMap(v) || I.List.isList(v)) {
      v.forEach((v2, k2) => getPath(v2, path.push(k2)));
    } else {
      ret = ret.push(path);
    }
  };
  o.forEach((v, k) => {
    getPath(v, I.List([k]));
  });
  return ret;
}

// Maps query paths to UUID.
export default function queryUUIDPaths(query: {}) {
  const queryMap = I.fromJS(query);
  const items: I.List<I.List<string>> = collPaths(queryMap);
  return items.map(path => {
    const keyPath = path.toArray();
    const newKey = queryMap.getIn(keyPath, '');
    return path
      .push(newKey)
      .filterNot(v => Number.isInteger(v))
      .filter(v => Boolean(v));
  });
}
